module.exports = __webpack_public_path__ + "img/2.6.5899b4cf.png";